@if (stepIndicatorViewModel) {
  <tm-step-indicator
    (selectedChange)="onSelectedStepChange($event)"
        (beforeStepChange)="
            onBeforeStepChange($event.cb, $event.arg, $event.isBack)
        "
    [compact]="isCompact"
    [selected]="selectedStepId"
    class="tm-property-tabs__step-indicator"
    >
    @for (step of stepIndicatorViewModel.steps; track step.stepId; let isLast = $last) {
      @if (step.isVisible) {
        <tm-step-indicator-item
          [disabled]="step.isDisabled"
          [id]="step.stepId"
          [title]="step.title"
          >
          <ng-container *tmStepIndicatorIcon>
            @if (step.isCheckmarkVisible) {
              <tg-icon
                name="basic-tick-framed"
                role="presentation"
                >
              </tg-icon>
            }
            @if (step.isCrossVisible) {
              <tg-icon
                name="stop"
                role="presentation"
                tgStyle="danger"
                >
              </tg-icon>
            }
            @if (
              !isCompact &&
              !isLast &&
              !step.isCheckmarkVisible &&
              !step.isCrossVisible &&
              stepIndicatorViewModel.selectedStepId !==
              step.stepId
              ) {
              <tg-icon
                name="basic-arrow-right"
                role="presentation"
                size="small"
                >
              </tg-icon>
            }
          </ng-container>
        </tm-step-indicator-item>
      }
    }
  </tm-step-indicator>
}
